import { useMemo } from 'react';
import styles from '../styles.module.scss';

const fontSizes = ['14', '16', '24', '36'];

export default function FontSizePicker({ onClick }) {
  const handleOnClick = (event) => {
    if (!onClick) return;

    const fontSize = event.target.dataset.value;
    if (fontSize) {
      onClick(fontSize);
    }
  };

  const renderFontSizeButton = (fontSize, onClickHandler) => (
    <button
      key={fontSize}
      className={styles['dropdown-item']}
      type="button"
      onClick={onClickHandler}
      data-event="backFontSize"
      data-value={fontSize}
    >
      {fontSize}
    </button>
  );

  const renderDropdownItems = useMemo(() => {
    const dropdown = [];
    for (let i = 0; i < fontSizes.length; i++) {
      const fontSize = fontSizes[i];
      dropdown.push(renderFontSizeButton(fontSize, handleOnClick));
    }

    return dropdown;
  }, [fontSizes]);

  return <div className={styles.dropdown}>{renderDropdownItems}</div>;
}
